module.exports = __webpack_public_path__ + "static/img/business74.411be2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business74.png
// module id = ION/
// module chunks = 9